<script lang="ts" setup>
interface Props {
  text?: string
  retry?: boolean
  icon?: string
  severity?: string
  onRetry?: (evt: Event) => void
}

withDefaults(defineProps<Props>(), {
  text: 'Reintentar buscar lista',
  icon: 'icon-[ph--arrow-counter-clockwise-bold]',
  severity: 'warning',
  onRetry: undefined,
})
</script>

<template>
  <PvInputGroup v-if="retry">
    <PvInputGroupAddon class="flex-grow">
      <span class="text-sm">{{ text }}</span>
    </PvInputGroupAddon>

    <PvButton
      :icon
      :severity
      @click="onRetry"
    />
  </PvInputGroup>
  <slot v-else />
</template>
